<template>
  <div id="app">
    <div class="header-placeholder">
      <header :class="{active : navToggle}">
        <div class="wrap">

          <router-link class="back-btn"
          v-if="$routerHistory.hasPrevious()"
          :to="{ path: $routerHistory.previous().path }">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g transform="translate(484 -732)"><circle class="a" cx="11" cy="11" r="11" transform="translate(-484 732)"/><path d="M995.642,1898.267h-9.8c2.212-1.967,4.842-4.336,4.872-4.363a1.038,1.038,0,1,0-1.394-1.537c-.391.352-3.879,3.493-6.079,5.432-.019.017-.037.034-.055.052a1.985,1.985,0,0,0-.023,2.7,1.535,1.535,0,0,0,.114.116l6.25,5.558a1.038,1.038,0,1,0,1.379-1.551l-4.87-4.33h9.609a1.038,1.038,0,0,0,0-2.075Z" transform="translate(-1462.642 -1156.095)"/></g></svg>

          </router-link>




          <button  class="nav-toggle" @click="navToggle = !navToggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
              <g id="Group_121" data-name="Group 121" transform="translate(-1739 -333)">
                <path id="Path_124" data-name="Path 124" d="M0,0H17" transform="translate(1740.5 348.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
                <path id="Path_122" data-name="Path 122" d="M0,0H17" transform="translate(1740.5 341.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
                <path id="Path_123" data-name="Path 123" d="M0,0H17" transform="translate(1740.5 334.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/>
              </g>
            </svg>
          </button>
          <h1>Gravitational Wave <br><span class="big-text">Calculator</span></h1>


          <router-link to="/" class="home-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="22.002" viewBox="0 0 27 22.002"><g transform="translate(0 0)"><path class="a" d="M-816.4,175.98l-5.709-4.371v-3.643c0-.239-.091-.433-.2-.433h-1.721c-.112,0-.2.194-.2.433v2.016l-3.78-2.9a2.257,2.257,0,0,0-1.568-.628,2.256,2.256,0,0,0-1.568.628l-11.615,8.894a.815.815,0,0,0-.152,1.139.8.8,0,0,0,.642.319.8.8,0,0,0,.49-.166l1.658-1.27v10.213a2.318,2.318,0,0,0,2.38,2.245h5.551c-.118-.2,0-.44,0-.692v-.932h-5.551a.713.713,0,0,1-.764-.621V174.764l8.379-6.416a.9.9,0,0,0,.082-.071.654.654,0,0,1,.468-.194.655.655,0,0,1,.468.195.823.823,0,0,0,.083.071l8.532,6.534v11.333a.7.7,0,0,1-.764.621h-5.706v.932c0,.252.118.488,0,.692h5.706a2.318,2.318,0,0,0,2.38-2.245V176.12l1.5,1.151a.8.8,0,0,0,1.132-.153A.816.816,0,0,0-816.4,175.98Z" transform="translate(843.084 -166.458)"/><path class="a" d="M-785.2,192.23a.716.716,0,0,1-.071-.062.564.564,0,0,0-.4-.168.563.563,0,0,0-.4.168.771.771,0,0,1-.07.062l-7.223,5.55v9.9a.615.615,0,0,0,.659.538h4.5V204.06a1.383,1.383,0,0,1,1.374-1.385h2.461A1.383,1.383,0,0,1-783,204.06v4.163h4.5a.607.607,0,0,0,.659-.538v-9.8Z" transform="translate(799.108 -189.052)"/></g></svg>
          </router-link>
        </div>
      </header>
    </div><!-- .header-placeholder -->
    <div class="container">
      <div id="nav" :class="{active : navToggle}">

        <router-link to="/"><span>Home</span></router-link>
        <router-link to="/about"><span>About Us</span></router-link>
        <router-link to="/pulsarmaps"><span>Sensitivity Maps</span></router-link>
        <router-link to="/pulsartiming"><span>Pulsar Timing for Dummies</span></router-link>
        <router-link to="/game"><span>Game</span></router-link>
        <router-link to="/citations"><span>Citations</span></router-link>

        <h2><img src="./assets/gold-arrow.svg" alt="arrow"> Try Me!</h2>

        <router-link to="/?do=hds">
          <span class="gold">Hypothetical Desirable Source</span>
        </router-link>
        <router-link to="/?do=3c66b">
          <span class="gold">3C 66B</span>
        </router-link>

      </div>

      <transition name="slide-fade" mode="out-in">
        <router-view/>
      </transition>

    </div>
  </div>
</template>

<script type="text/javascript">
  export default{
    name: 'app',
    data(){
      return{
        navToggle: false
      }
    },
    methods:{
      prevent: function(e){
        if(this.navToggle == true){
          e.preventDefault();
          e.stopPropagation();
        }

      }
    },
    watch: {
      '$route': function() {
        this.navToggle = false
      }
    }
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:300,400,700|Roboto:400,700');

$blue: #27AAE1;
$gold: #FCBB07;
$orange: #F7941E;
$paleGold: #FCDB7E;
$grey: #222222;
$break: 678px;

html {
  box-sizing: border-box;
}
*, *:before, *:after {
  box-sizing: inherit;
}

input {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
}

img { max-width: 100%; height: auto; }

html { overflow-y: scroll; }
body {
  font-family: 'Roboto Condensed', sans-serif;
  background: $grey;
  color: #fff;
  padding: 0;
  padding-bottom: 20px;
  margin: 0;

}

.header-placeholder{
  height: 160px;
  width: 100%;

  @media(min-width: $break){
    height: auto;
    width: auto;
  }
}
header {
  background: #000;
  margin-bottom: 30px;
  position: relative;
  overflow: hidden;

  &.active{

    @media (max-width: $break){
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background: #000;
      z-index: 20;
    }


  }


  h1 {
    margin: 0;
    padding: 1em 0;
    position: relative;
    z-index: 10;
    overflow: hidden;
    text-transform: uppercase;
    font: normal 1.5em/1.3em 'Roboto', sans-serif;

    .big-text{
      padding-bottom:5px;
      border-bottom: solid 4px $blue;
      font-size: 1.65em;
      display: inline-block;
      font-weight: bold;
      letter-spacing: 1px;
    }


  }

  .nav-toggle{
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
    position: relative;
    z-index: 10;
    margin-top: 20px;

    @media (min-width: $break){
      display: none;
    }
  }

  &:before {
    width: 200px;
    height: 200px;
    position: absolute;
    top:-71px;
    left:calc(50% - 100px);
    background: transparent url("./assets/spinning-hole.svg") no-repeat center center;
    content: '';
    display: block;
    z-index: -1;
    animation: spin 12s infinite linear;
    z-index: 5;

    @media (min-width: $break){
      width: 300px;
      height: 300px;
      top:calc(50% - 150px);
      left:calc(50% - 150px);
    }
  }
}

.home-icon {
  position: absolute;
  right: 0px;
  top: 5px;
  @media (min-width: $break){ top: 30%; }
  padding: 10px;
  z-index: 11;
  svg .a {
    fill: #27aae1;
    transition: all 0.2s ease;
  }
  &:hover svg .a { fill: #ffffff; }
}

.back-btn{
  position: absolute;
  left: 0px;
  top: 5px;
  @media (min-width: $break){ top: 30%; }
  padding: 10px;
  z-index: 11;
  svg .a {
    fill: #27aae1;
    transition: all 0.2s ease;
  }
  &:hover svg .a { fill: #ffffff; }
}

@keyframes spin {
  0%   {transform: rotate(0deg); }
  100% {transform: rotate(-360deg); }
}
#app {
  font-family: 'Roboto Condensed', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;

  &.active{
    position: relative;
    overflow-x: hidden;
  }
  a {
    color: #fa5;
  }
}
.container {
  display: flex;
  flex-align: flex-start;
  justify-content: center;
}
.container, .wrap {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
}

#nav {
  flex: 0 0 305px;
  padding: 30px;
  position: fixed;
  width: 100%;
  height: calc(100% - 160px);
  background: #000;
  top: 160px;
  left: -150%;
  margin: 0;
  transition: all 0.5s;
  overflow-x: scroll;

  &.active{
    left: 0;
  }

  @media(min-width: $break){
    position: static;
    height: auto;
    border-right: solid 1px $paleGold;
    margin-right: 25px;
    background: $grey;
    padding: 0 5px 30px 30px;
    overflow-x: auto;
  }

  h2{
    text-align: left;
    color: $gold;
    max-width: 250px;
    width: 90%;
    margin: 30px auto 10px auto;
    text-transform: uppercase;
  }

  a {
    display: block;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
    border: solid 1px #fff;
    width: 90%;
    max-width: 250px;
    padding: 3px;
    margin: 10px auto;


    span{
      color: #000;
      background: #fff;
      width: 100%;
      display: block;
      font-size: 16px;
      padding: 10px;
      transition: all 0.25s;

      &.blue{
        background: $blue;
        color: #fff;
      }

      &.gold{
        background: $gold;
        color: #000;
      }

      @media (min-width: $break){
        &:hover{
          background: $blue;
          color: #fff;
          &.gold {
            background: $orange;
            color: #fff;
          }
        }
      }
    }


    &.router-link-exact-active {
      text-decoration: underline;
      span {
        background: $blue;
        color: #fff;
        &.gold {
          background: $orange;
          color: #fff;
        }
      }
    }
  }
}
#nav + div {
  flex: 3;
  padding: 0 15px;
  max-width: 500px;
  text-align: left;
  @media (min-width: $break){
    padding: 0 30px 0 10px;
  }

  h1{
    margin-top: 20px;
    padding: 0;
    font-weight: 300;

    @media (min-width: $break){
      margin-top: 0;
    }
  }

  .fieldset{
    border: none;
    display: flex;
    flex-wrap: wrap;
    padding: 12px 0;

    .legend{
      font-size: 22px;
      color: $gold;
      display: block;
      border-bottom: dotted $blue;
      width: 100%;
    }
  }

  p{
    color: $paleGold;
    margin: 10px 0;
  }

  .input-wrap{
    width: 100%;
    margin: 10px 0;

    @media (min-width: 850px){
      flex:1 1 50%;
    }

    input{
      border: solid 1px $blue;
      color: $grey;
      outline: none;
      font-size: 1.1em;
      padding: 10px 10px;
      width: calc(100% - 100px);
      transition: all 0.25s;

      @media (min-width: 850px){
        width: 170px;
        padding: 5px 10px;
      }

      &:focus{
        border: solid 1px $gold;
      }
    }
  }

  .submit-wrap{
    padding: 10px 0;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;

    @media (min-width: $break){
      justify-content: flex-end;
    }
    &.two { display: block; }
  }

  .button{
    display: block;
    width: 90%;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
    border: solid 1px #fff;
    width: 100%;
    padding: 5px;
    margin: 10px 0;
    background: none;
    transition: all 0.25s;

    @media (min-width: $break){
      width: 250px;
      padding: 3px;
    }

    span{
      color: #fff;
      background: $orange;
      font-family: 'Roboto Condensed', sans-serif;
      width: 100%;
      display: block;
      font-size: 24px;
      padding: 15px 10px;
      text-align: center;
      text-transform: uppercase;
      -webkit-transition: all 0.25s;
      transition: all 0.25s;
      border: none;
      outline: none;
      cursor: pointer;

      @media (min-width: $break){
        padding: 10px;
        font-size: 16px;
      }
    }

    &:hover{
      span{
        background: $blue;
      }
    }
    &.blue {
      span { background: $blue; }
      &:hover { span { background: #fff; color: #000;; } }
    }
  }

}

.slide-fade-enter-active {
  transition: all .4s ease-out;
}
.slide-fade-leave-active {
  transition: all .3s ease-in;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-15px) scale(0.98);
  transform-origin: 50% 200px;
  opacity: 0.1;
}

</style>
